import axios from 'axios';
// const baseURL = baseUrl()
const baseURL = process.env.REACT_APP_URL
axios.defaults.baseURL = baseURL

const updateKey = () => {
    let user = undefined
    try {
        user = JSON.parse(localStorage.getItem("auth") || '{}')
        // console.log("auth session", user)
    } catch (err) { }
    if (user?.token) {
        // console.log("token applied", user)
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.token
        // console.log("header", axios.defaults.headers.common['Authorization'])
    } else {
        axios.defaults.headers.common['Authorization'] = null
        localStorage.setItem("auth", null)
    }
}
const handleError = (error) => {
    console.log("handleError", error)

    if (error?.message === "Network Error") {
        return { status: 0, error: true, message: "Network lost. Please check your internet connection." }
    }

    const status = error?.response?.status
    const responseData = error?.response?.data

    if (status === 403) {
        return { status, error: true, message: responseData?.message || "Permission denied." }
    }

    // Structured validation error from backend (our new format)
    if (typeof responseData === 'object' && responseData !== null) {
        // New structured format: { detail, errors: { field: { label, message } } }
        if (responseData?.errors) {
            const fieldMessages = Object.values(responseData.errors)
                .map(e => e?.message || '')
                .filter(Boolean)
            const combinedMessage = fieldMessages.length
                ? fieldMessages.join('\n')
                : (responseData?.detail || "Validation failed.")
            return {
                status,
                error: true,
                message: combinedMessage,
                errors: responseData.errors,  // pass structured errors up for field display
                detail: responseData.detail,
            }
        }
        // DRF default format: { field: ["error msg"] } or { detail: "..." }
        if (responseData?.detail) {
            return { status, error: true, message: responseData.detail }
        }
        // Build message from field: [errors] format
        const fieldMessages = Object.entries(responseData)
            .map(([field, errs]) => {
                const label = field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
                const msgs = Array.isArray(errs) ? errs.join('; ') : String(errs)
                return `${label}: ${msgs}`
            })
        return { status, error: true, message: fieldMessages.join('\n') || "An error occurred." }
    }

    return { status, error: true, message: String(responseData) || "An error occurred." }
}

const handleAuth = (data) => {
    if (data?.code == 401) {
        localStorage.setItem("auth", null)
        axios.defaults.headers.common['Authorization'] = null
        return data
    }
}

export const getRequest = async (url) => {
    console.log("API", url)
    updateKey()

    try {
        const todos = await axios.get(url)
        handleAuth(todos.data)
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}

// Create New Todo
export const postRequest = async (url, data) => {
    updateKey()
    if (url == "token/") {
        axios.defaults.headers.common["Authorization"] = null;
    }
    // axios.defaults.headers.common["content-type"] = 'multipart/form-data'
    console.log("post called", url)
    try {
        const todos = await axios.post(url, data)
        console.log("API todos..", todos?.data)
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}
export const putRequest = async (url, data) => {
    console.log("put called", url)
    updateKey()
    try {
        const todos = await axios.put(url, data);
        todos.data.data.message = todos.data.message
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}
//patch
export const patchRequest = async (url, data) => {
    updateKey()
    console.log("patch called", url)
    try {
        const todos = await axios.patch(url, data);
        return { ...todos.data, message: todos.data.message }
    } catch (err) {
        return handleError(err)
    }
}


// Delete existed todo
export const delRequest = async (url, id) => {
    updateKey()
    console.log(url, id)
    url = `${url}${id}/`
    try {
        const todos = await axios.delete(url);
        return { ...todos.data, message: todos.data.message }
        //let data = await axios.delete(url)
        // console.log("DEL DATA", data);
        //return id
    } catch (err) {
        return handleError(err)
    }
}

